import H from 'constants/httpMethod.const';
import mockJsonResponse from 'utils/backend/mockJsonResponse.util';
import { isEnvDev } from 'utils/env/determine.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

import { MOCK_FORMS } from './consultationForms.mock';

const IS_DEV = isEnvDev();

const mock$beConsultationFormsRead = () =>
  mockJsonResponse({
    status: 200,
    body: { forms: MOCK_FORMS },
  });

const beConsultationFormsRead = actionEndpointBe('beConsultationFormsRead', H.get, 'consultation/forms/:salonId/', (options) => ({
  ...options,
  inert: true,
  mock: IS_DEV ? mock$beConsultationFormsRead : void 1,
}));

export default beConsultationFormsRead;
